export const SEAT_COUNT = 11;

export type SeatAnchor = {
  seat: number;
  x: number;
  y: number;
  align: 'left' | 'center' | 'right';
  position: string;
};

// Follow the outer rail while leaving the dealer's top-center lane open.
export const SEAT_ANCHORS: SeatAnchor[] = [
  { seat: 0, x: 50, y: 88, align: 'center', position: 'bottom-center' },
  { seat: 1, x: 31, y: 87, align: 'left', position: 'bottom-left' },
  { seat: 2, x: 14, y: 73, align: 'left', position: 'left-lower' },
  { seat: 3, x: 9, y: 51, align: 'left', position: 'left-center' },
  { seat: 4, x: 15, y: 29, align: 'left', position: 'left-upper' },
  { seat: 5, x: 31, y: 14, align: 'left', position: 'top-left' },
  { seat: 6, x: 69, y: 14, align: 'right', position: 'top-right' },
  { seat: 7, x: 85, y: 29, align: 'right', position: 'right-upper' },
  { seat: 8, x: 91, y: 51, align: 'right', position: 'right-center' },
  { seat: 9, x: 86, y: 73, align: 'right', position: 'right-lower' },
  { seat: 10, x: 69, y: 87, align: 'right', position: 'bottom-right' },
];
